<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<template>
  <div class="page-title">
    <i class="fa-solid fa-container-storage"></i>
    <span class="space-icon"></span>
    {{ container.container_code }}
    <span
      :class="[
        'px-2 py-1 text-xs font-medium rounded-full text-white',
        container.export_invoices_paid ? 'bg-green-500' : 'bg-red-500'
      ]"
    >
      {{ container.export_invoices_paid ? "Pagado" : "No pagado" }}
    </span>
  </div>
  <div class="panel">
    <div class="panel-body">
      <div class="divide-gray-200">
        <div class="grid grid-cols-1 gap-y-8 gap-x-4 sm:grid-cols-6">
          <div class="sm:col-span-2">
            <dt class="label-data">
              {{ $t("model.container.week") }}
            </dt>
            <dd class="content-data">
              {{ container.week }}
            </dd>
          </div>
          <div class="sm:col-span-2">
            <dt class="label-data">{{ $t("model.container.customer") }}:</dt>
            <dd class="content-data">{{ container.customer?.name }}</dd>
          </div>
          <div class="sm:col-span-2">
            <dt class="label-data">
              {{ $t("model.container.exporter_process_brand") }}:
            </dt>
            <dd class="content-data">
              {{ container?.brand_name }}
            </dd>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AEFinancesContainerIncomesContainerInfo",
  props: {
    container: {
      type: Object,
      required: true
    }
  }
};
</script>
